// extracted by mini-css-extract-plugin
export default {"wrapper":"carousel-item-module--wrapper--7fb98"};